import { lazyWithReload } from "./lazyWithReload";

export const LazyDashboard = lazyWithReload(() => import("../../Pages/Dashboard"));

export const LazyDoors = lazyWithReload(() => import("../../Pages/Doors"));

export const LazyDetailDoor = lazyWithReload(() => import("../../Pages/Doors/DetailDoor"));

export const LazyCameras = lazyWithReload(() => import("../../Pages/Cameras"));

export const LazyHubs = lazyWithReload(() => import("../../Pages/Hubs"));

export const LazyDetailHub = lazyWithReload(() => import("../../Pages/Hubs/DetailHubs"));

export const LazyDetailCamera = lazyWithReload(() => import("../../Pages/Cameras/DetailCameras"));

export const LazySettings = lazyWithReload(() => import("../../Pages/Settings"));

export const LazyLogs = lazyWithReload(() => import("../../Pages/Logs"));

export const LazyLicenseLogs = lazyWithReload(() => import("../../Pages/LicenseLogs"));

export const LazyUsers = lazyWithReload(() => import("../../Pages/Users"));

export const LazyDetailUser = lazyWithReload(() => import("../../Pages/Users/DetailUser"));

export const LazySupportUser = lazyWithReload(() => import("../../Pages/SupportUsers/index"));

export const LazySupportUserDetail = lazyWithReload(
  () => import("../../Pages/SupportUsers/SupportUserDetail")
);

export const LazyCustomerRequests = lazyWithReload(() => import("../../Pages/CustomerRequests"));

export const LazyPartner = lazyWithReload(() => import("../../Pages/Partner"));

export const LazyShipping = lazyWithReload(() => import("../../Pages/Shipping"));

export const LazySensors = lazyWithReload(() => import("../../Pages/Sensors"));
export const LazyDetailSensor = lazyWithReload(() => import("../../Pages/Sensors/DetailSensor"));

export const LazyAccountDeviceSubscription = lazyWithReload(
  () => import("../../Pages/AccountDeviceSubscription")
);

export const LazyGateway = lazyWithReload(() => import("../../Pages/Gateway"));
export const LazyDetailAppliances = lazyWithReload(
  () => import("../../Pages/Gateway/AppliancesDetails")
);
